'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var $catalogNav = (0, _jquery2.default)('#catalogNav', this);

  function init() {
    if ($catalogNav.length === 0 || (0, _jquery2.default)('body').hasClass('homepage')) return;

    if ((0, _linksoftAlbatros.isMaxWidth)('sm')) {
      $catalogNav.trigger("sticky_kit:detach");
    } else {
      $catalogNav.stick_in_parent();
    }
  }

  init();

  (0, _jquery2.default)(window).on('resize', _jquery2.default.debounce(200, init));

  (0, _jquery2.default)('.filter__trigger').on('click', function () {
    setTimeout(function () {
      $catalogNav.trigger("sticky_kit:recalc");
    }, 400);
  });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./../vendors/sticky-kit');

require('linksoft-albatros/src/plugins/jquery-throttle-debounce');

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/stickyCatalogMenu.js
// module id = 1189
// module chunks = 0